import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class FormatService {
  options = {
    year: "numeric",
    month: "short",
    day: "numeric"
  };

  formatDate(date: any) {
    if (date != null && date != "" && date != undefined) {
      // Convert to Date object if it's a string
      const dateObj = typeof date === "string" ? new Date(date) : date;
      // Adjust for timezone offset to get the correct local date
      // The Material datepicker stores time at 00:00:00 local time,
      // but we need to account for timezone shift when formatting
      const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
      const localDate = new Date(dateObj.getTime() - timezoneOffset);
      // Format as YYYY-MM-DD (proper ISO date format for backend)
      const year = localDate.getFullYear();
      const month = ("0" + (localDate.getMonth() + 1)).slice(-2);
      const day = ("0" + localDate.getDate()).slice(-2);
      const formattedDate = year + "-" + month + "-" + day;

      return formattedDate;
    }
    return null;
  }

  formatNewDate(date: any) {
    if (date != null && date != "" && date != undefined) {
      let localDate = new Date(date);
      return localDate;
    }
    return null;
  }
}
